var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", wrap: "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "", sm6: "", md6: "" } },
        [
          _c("v-select", {
            staticClass: "styled-select",
            staticStyle: { "margin-top": "8px" },
            attrs: {
              label: "Alerta Base",
              items: _vm.lstAlertasBaseFiltro,
              "item-text": "nombre",
              "item-value": "id",
              disabled: _vm.accion === 3
            },
            on: {
              change: function($event) {
                return _vm.setTipoAlertaBase($event)
              }
            },
            model: {
              value: _vm.tipoAlerta,
              callback: function($$v) {
                _vm.tipoAlerta = $$v
              },
              expression: "tipoAlerta"
            }
          })
        ],
        1
      ),
      _c(
        "v-flex",
        { attrs: { xs12: "", sm6: "", md6: "" } },
        [
          _c("v-select", {
            staticClass: "styled-select",
            staticStyle: { "margin-top": "8px" },
            attrs: {
              label: "Tipo Alerta",
              items: _vm.lstAlertasCliente,
              "item-text": "nombre",
              "item-value": "id",
              disabled: _vm.accion === 3,
              multiple: "",
              flat: "",
              "no-data-text": "Sin resultados"
            },
            on: {
              change: function($event) {
                return _vm.setTipoAlertaCliente($event)
              }
            },
            scopedSlots: _vm._u([
              {
                key: "selection",
                fn: function(ref) {
                  var item = ref.item
                  var index = ref.index
                  return [
                    index === 0
                      ? _c("v-chip", { attrs: { small: "" } }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.textoComprimido(item.nombre)))
                          ])
                        ])
                      : _vm._e(),
                    index === 1
                      ? _c("span", { staticClass: "grey--text caption" }, [
                          _vm._v(
                            "(+" +
                              _vm._s(_vm.tipoAlertaCliente.length - 1) +
                              " Alertas)"
                          )
                        ])
                      : _vm._e()
                  ]
                }
              }
            ]),
            model: {
              value: _vm.tipoAlertaCliente,
              callback: function($$v) {
                _vm.tipoAlertaCliente = $$v
              },
              expression: "tipoAlertaCliente"
            }
          })
        ],
        1
      ),
      _c(
        "FormFieldsContainer",
        [
          _c(
            "v-flex",
            [
              this.show
                ? _c("v-checkbox", {
                    attrs: {
                      label: _vm.formFields.checkEtiqueta.label,
                      disabled: _vm.accion === 3
                    },
                    on: { change: _vm.checkAlertas },
                    model: {
                      value: _vm.formFields.checkEtiqueta.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.checkEtiqueta, "value", $$v)
                      },
                      expression: "formFields.checkEtiqueta.value"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "v-flex",
            [
              this.show
                ? _c("v-checkbox", {
                    attrs: {
                      label: _vm.formFields.checkColor.label,
                      disabled: _vm.accion === 3
                    },
                    on: { change: _vm.checkAlertas },
                    model: {
                      value: _vm.formFields.checkColor.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.checkColor, "value", $$v)
                      },
                      expression: "formFields.checkColor.value"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "v-flex",
            [
              this.show
                ? _c("v-checkbox", {
                    attrs: {
                      label: _vm.formFields.checkHDOP.label,
                      disabled: _vm.accion === 3
                    },
                    on: { change: _vm.checkAlertas },
                    model: {
                      value: _vm.formFields.checkHDOP.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.checkHDOP, "value", $$v)
                      },
                      expression: "formFields.checkHDOP.value"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "v-flex",
            [
              this.show
                ? _c("v-checkbox", {
                    attrs: {
                      label: _vm.formFields.checkSatelite.label,
                      disabled: _vm.accion === 3
                    },
                    on: { change: _vm.checkAlertas },
                    model: {
                      value: _vm.formFields.checkSatelite.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.checkSatelite, "value", $$v)
                      },
                      expression: "formFields.checkSatelite.value"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }